import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { useScreenSize } from 'hooks/useScreenSize'
import { CreativeImportDialog } from './CreativeImportDialog'

export const CreativeImportButton = () => {
  const { isMobile } = useScreenSize()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant="outlined" color="primary" onClick={() => setOpen(true)}>
        {isMobile ? '⬆' : 'Import Ads'}
      </Button>
      {open && <CreativeImportDialog open={open} onClose={() => setOpen(false)} />}
    </>
  )
}
